module.exports = __webpack_public_path__ + "img/marketplace_IG.e833ecde.svg";